<template>
  <div class="form__description text-center">
    Choose  your size, color, and options when applicable...
  </div>
</template>
<script>
export default {
  name: 'FormDescription'
}
</script>